module.exports = __webpack_public_path__ + "static/media/TUNE_3080.772ff9ab.jpg";